type StringValue<T> = string | ((item: T) => string);

interface ActionBase<T> {
  type: 'executed' | 'link';
  name: StringValue<T>;
  icon: StringValue<T>;
  isVisible: (item: T) => boolean;
}

export interface ExecutedAction<T> extends ActionBase<T> {
  type: 'executed',
  execute: (item: T, selection?: T[]) => void;
}

export interface LinkAction<T> extends ActionBase<T> {
  type: 'link',
  generateLink: (item: T) => string;
}

export interface Spacer {
  type: 'spacer';
}

export type Action<T> = ExecutedAction<T> | LinkAction<T>;
export type ContextAction<T> = Action<T> | Spacer;

export const makeAction = <T>(name: StringValue<T>, icon: StringValue<T>, execute: (item: T, selection?: T[]) => void,
                              isVisible = (_: T) => true): Action<T> => {
  return {
    type: 'executed', name, icon, execute, isVisible};
}

export const makeLink = <T>(name: StringValue<T>, icon: StringValue<T>, generateLink: (item: T) => string,
                            isVisible = (_: T) => true): Action <T> => {
  return { type: 'link', name, icon, generateLink, isVisible };
}

export const makeSpacer = (): ContextAction<any> => ({ type: 'spacer' });

export const isActionVisibiltyCompatible = <T>(action: Action<T>, current: T, all: Map<string | number, T>) => {
  if (!action.isVisible(current)) {
    return false;
  }

  for (const [, value] of all) {
    if (!action.isVisible(value)) {
      return false;
    }
  }
  return true;
}

export const isAction = <T>(action: ContextAction<T>): action is Action<T> => {
  return action.type !== 'spacer';
}

export const filterRegularActions = <T>(actions: Array<ContextAction<T>> | undefined): Array<Action<T>> | undefined => {
  return actions && actions.filter(action => action.type !== 'spacer') as Array<Action<T>>;
}
